import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  withStyles,
  Grid,
  DialogActions,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  FormHelperText,
} from '@material-ui/core';
import Swal from 'sweetalert2';
import './styles/patientview.css';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage } from '../../utils/common';
import config from '../../config';

// const errRequired = 'required_field';
// const errPassword = 'passwords_dont_match';
// const errPasswordLength = 'password_length';

class ChangePassword extends React.PureComponent {
  onTextChange = (key, value) => {
    this.props.user.changeData(key, value);
  };

  getConfigAuthMode = () => {
    let authMode = 'cognito';
    if (config.features && config.features.auth && config.features.auth.authMode) {
      authMode = config.features.auth.authMode;
    }
    return authMode;
  };

  handleSubmit = async () => {
    // const x = config.features.auth.authMode;

    const { t, props } = this.props;
    const { data } = this.props.user.toJS();
    if (data.password.newPassword.length >= 6 && data.password.confirmPassword.length >= 6) {
      try {
        if (data.password.newPassword === data.password.confirmPassword) {
          let result = null;
          if (this.getConfigAuthMode() === 'cognito') {
            // authMode is cognito
            result = await this.props.user.updatePassword(data, localStorage.getItem('user_id'));
          } else {
            // authMode is local
            result = await this.props.user.resetPassword(data, localStorage.getItem('user_id'));
          }
          if (result.statusCode === 200) {
            Swal.fire({
              html: `<h4>${t('changed_password')}`,
              type: 'success',
              customClass: {
                container: 'my-swal',
              },
            }).then(() => {
              this.props.handleClose();
              props.closeProfileMenu();
              clearLocalStorage();
              window.location.href = '/login';
            });
          }
        } else {
          this.props.user.setError();
        }
      } catch (e) {
        if (e.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else {
          Swal.fire({ html: `<h4>${e.error.message}`, type: 'error' });
        }
      }
    } else {
      Swal.fire({ html: `<h4>${t('password_length')}`, type: 'error' });
    }
  };

  render() {
    let { classes, state, t } = this.props;
    let { data } = this.props.user.toJS();
    return (
      <Dialog
        open={state.dialogChangePasswordOpen}
        onClose={this.props.handleClose}
        aria-labelledby='form-dialog-title'
        maxWidth='xs'
        fullWidth={true}
      >
        <DialogTitle
          id='form-dialog-title'
          classes={{
            root: classes.MuiDialogTitle,
          }}
        >
          <Typography variant='h6'>{t('changePassword')}</Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item md={12} xs={12}>
              <TextField
                id='current_password'
                label={t('currentPassword')}
                placeholder={t('enter_current_password')}
                type='password'
                onChange={(e) => this.onTextChange('currentPassword', e.target.value)}
                fullWidth
                inputProps={{
                  autoComplete: 'new-password',
                }}
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                id='new_password'
                label={t('newPassword')}
                placeholder={t('enter_new_password')}
                type='password'
                onChange={(e) => this.onTextChange('newPassword', e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                id='confirm_password'
                label={t('confirmPassword')}
                placeholder={t('confirm_new_password')}
                type='password'
                error={data.error}
                onChange={(e) => this.onTextChange('confirmPassword', e.target.value)}
                fullWidth
              />
              <FormHelperText error hidden={data.error ? false : true} id='component-error-text'>
                {t('passwords_dont_match')}
              </FormHelperText>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.handleClose} color='default'>
            {t('cancel')}
          </Button>
          <Button
            onClick={this.handleSubmit}
            color='primary'
            variant='contained'
            disabled={data.password.currentPassword && data.password.currentPassword !== '' ? false : true}
          >
            {t('save')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  MuiDialogTitle: {
    padding: '10px 24px 2px',
  },
});

export const page = inject('user')(observer(ChangePassword));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
